import { Inject, Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';

import { ITenaEpiRule } from '../../../../model/product/tena/ITenaEpiRule';
import { ApiErrorHandler } from 'tridion.web.ui/src/app/angular/api/error/ApiErrorHandler';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { ENVIRONMENT } from 'tridion.web.ui/src/app/angular/environment/ENVIRONMENT';
import { IEnvironment } from '../../../../environment/IEnvironment';
import { TenaService } from '../../../../product/tena/Tena.service';
import { BaseTCWCatalogApi } from './BaseTCWCatalogApi';
import { LiveStageService } from '../../../../environment/LiveStage.service';
import { TenaTCWCatalogApi } from './TenaTCWCatalogApi';
import { ITenaTCWCatalog } from '../../../../model/product/tena/tcw/ITenaTCWCatalog';

@Injectable()
export class TenaEpiRulesApi extends BaseTCWCatalogApi<ITenaEpiRule> {
    constructor(
        apiErrorHandler: ApiErrorHandler,
        authService: AuthService,
        @Inject(ENVIRONMENT) environment: IEnvironment,
        http: Http,
        tenaService: TenaService,
        readonly tenaService1: TenaService,
        liveStageService: LiveStageService,
        readonly tenaCatalogApi: TenaTCWCatalogApi
    ) {
        super(apiErrorHandler, authService, environment, http, tenaService, liveStageService);
    }

    getEpiRules(countryId: number): Observable<ITenaEpiRule[]> {
        return this.getJson(`/${countryId}`);
    }

    protected getBaseUrl() {
        this.tenaCatalogApi.getAll().subscribe((res: ITenaTCWCatalog[]) => {
            this.tenaService1.countries.next(res);
        });

        return this.TCWBaseURl + 'TENAEPIRules';
    }
}
